import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  NumberInputComponent,
  CheckboxInputComponent,
} from '@navstation-portal/shared/ui/components';
import { IsVisibleDirective } from '@navstation-portal/shared/ui/directives';
import {
  AbstractStoreConnectedSectionComponent,
  offshorePositionAndWeatherEvents,
  OffshorePositionAndWeatherFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-wind',
  templateUrl: './wind.component.html',
  imports: [
    FormsModule,
    NumberInputComponent,
    CheckboxInputComponent,
    IsVisibleDirective,
  ],
})
export class WindComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'positionAndWeather';
  sectionId = 'wind';
  events = injectDispatch(offshorePositionAndWeatherEvents);
  offshorePositionAndWeatherStore = inject(OffshorePositionAndWeatherFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
}
